import type { EventProps, Traits } from "./wisetap/types";

/**
 * AnalyticsProvider — the sink contract.
 *
 * A provider is one analytics destination (CleverTap, Wisetap, ...). The facade
 * fans every call out to the active providers from the registry. Concrete
 * providers override what they support; the rest stay no-ops.
 *
 * All methods are best-effort / fire-and-forget: a provider MUST NOT throw into
 * the caller.
 */
export class AnalyticsProvider {
  identify(_userId: string | number, _traits?: Traits): void {}

  track(_eventName: string, _props?: EventProps): void {}

  trackCharged(_details?: EventProps, _items?: unknown): void {}

  reset(): void {}

  flush(): void {}
}

export default AnalyticsProvider;
